import { render, staticRenderFns } from "./appraiser.vue?vue&type=template&id=b23dc032"
import script from "./appraiser.vue?vue&type=script&lang=js"
export * from "./appraiser.vue?vue&type=script&lang=js"
import style0 from "./appraiser.vue?vue&type=style&index=0&id=b23dc032&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports